import { useActionsQueueContext } from "./ActionsQueueContextProvider";

type UpdateActionsQeueu = (
  actionKey: string,
  actionValue: () => Promise<void>
) => void;

type RemoveActionsFromQueue = (idsToRemove: string[]) => void;

type ReturnType = {
  updateActionsQueue: UpdateActionsQeueu;
  removeActionsFromQueue: RemoveActionsFromQueue;
};

const useContextActions = (): ReturnType => {
  const { dispatch } = useActionsQueueContext();

  const updateActionsQueue: UpdateActionsQeueu = (actionKey, actionValue) =>
    dispatch({
      type: "UPDATE_ACTIONS_QUEUE",
      actionKey,
      actionValue,
    });

  const removeActionsFromQueue: RemoveActionsFromQueue = (idsToRemove) =>
    dispatch({
      type: "REMOVE_ACTIONS_FROM_QUEUE",
      idsToRemove,
    });

  return { updateActionsQueue, removeActionsFromQueue };
};

export default useContextActions;
